import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import ResetPassword from '../pages/auth/ResetPassword';
import AcceptInvite from '../pages/auth/AcceptInvite';
import TwoFactorSetup from '../pages/auth/TwoFactorSetup';
import TwoFactorVerify from '../pages/auth/TwoFactorVerify';
import Error404Page from '@/pages/error/Error404Page';
import Unauthorized from '@/pages/error/Unauthorized';
import Routes from './routes';
import SuperAdminDashboard from '@/pages/super-admin/SuperAdminDashboard';
import SuperAdminWrapper from '@/layouts/SuperAdminWrapper';
import SuperAdminOrganizations from '@/pages/super-admin/Organizations/SuperAdminOrganizations';
import SuperAdminSingleOrganization from '@/pages/super-admin/Organizations/SuperAdminSingleOrganization';
import SuperAdminWorkspaces from '@/pages/super-admin/Workspaces/SuperAdminWorkspaces';
import SuperAdminSingleWorkspace from '@/pages/super-admin/Workspaces/SuperAdminSingleWorkspace';
import SuperAdminProjects from '@/pages/super-admin/Projects/SuperAdminProjects';
import SuperAdminSingleProject from '@/pages/super-admin/Projects/SuperAdminSingleProject';
import SuperAdminUsers from '@/pages/super-admin/Users/SuperAdminUsers';
import SuperAdminSingleUser from '@/pages/super-admin/Users/SuperAdminSingleUser';
import SuperAdminsList from '@/pages/super-admin/SuperAdmins/SuperAdminsList';
import AuditLog from '@/pages/super-admin/AuditLog/AuditLog';
import SystemHealth from '@/pages/super-admin/SystemHealth/SystemHealth';
import MyAccount from '@/pages/super-admin/Account/MyAccount';

const RouterWrapper = () => {
  const router = createBrowserRouter([
    // -- PUBLIC ROUTES --

    {
      index: true,
      path: Routes.home.path,
      element: <App />,
    },
    {
      path: Routes.login.path,
      element: <Login />,
    },
    {
      path: Routes.forgot_password.path,
      element: <ForgotPassword />,
    },
    {
      path: Routes.reset_password.path,
      element: <ResetPassword />,
    },
    {
      path: Routes.accept_invite.path,
      element: <AcceptInvite />,
    },
    {
      path: Routes.two_factor_setup.path,
      element: <TwoFactorSetup />,
    },
    {
      path: Routes.two_factor_verify.path,
      element: <TwoFactorVerify />,
    },
    {
      path: Routes.unauthorized.path,
      element: <Unauthorized />,
    },
    // -- SUPER ADMIN ROUTES START --

    {
      element: <SuperAdminWrapper />,
      children: [
        {
          path: Routes.super_admin_dashboard.path,
          element: <SuperAdminDashboard />,
        },
        {
          path: Routes.super_admin_dashboard_organizations.path,
          element: <SuperAdminOrganizations />,
        },
        {
          path: `${Routes.super_admin_dashboard_single_organization.path}/:org_id`,
          element: <SuperAdminSingleOrganization />,
        },
        {
          path: Routes.super_admin_dashboard_workspaces.path,
          element: <SuperAdminWorkspaces />,
        },
        {
          path: `${Routes.super_admin_dashboard_single_workspace.path}/:workspace_id`,
          element: <SuperAdminSingleWorkspace />,
        },
        {
          path: Routes.super_admin_dashboard_projects.path,
          element: <SuperAdminProjects />,
        },
        {
          path: `${Routes.super_admin_dashboard_single_project.path}/:project_id`,
          element: <SuperAdminSingleProject />,
        },
        {
          path: Routes.super_admin_dashboard_users.path,
          element: <SuperAdminUsers />,
        },
        {
          path: `${Routes.super_admin_dashboard_single_user.path}/:user_id`,
          element: <SuperAdminSingleUser />,
        },
        {
          path: Routes.super_admin_dashboard_admins.path,
          element: <SuperAdminsList />,
        },
        {
          path: Routes.super_admin_dashboard_audit_log.path,
          element: <AuditLog />,
        },
        {
          path: Routes.super_admin_dashboard_system_health.path,
          element: <SystemHealth />,
        },
        {
          path: Routes.super_admin_dashboard_account.path,
          element: <MyAccount />,
        },
      ],
    },

    // -- CATCH ALL ERRORS --
    {
      path: '/404',
      element: <Error404Page />,
    },
    {
      path: '*',
      element: <Error404Page />,
    },
  ]);

  return router;
};

export default RouterWrapper;
